import type { FiltrosDocumentos } from '@/contexts/DocumentosContext';

/**
 * Aplica um filtro novo sobre os atuais (SPEC-018, §3, item 1).
 *
 * A busca única e os campos de participante, número e chave da janela Filtros procuram a mesma coisa. Vale o último
 * aplicado: aplicar a busca limpa esses campos da janela, e aplicar a janela com um deles limpa a busca. Antes, o
 * servidor fazia a janela vencer a busca, e um valor antigo esquecido na janela anulava a busca sem aviso.
 */
export function mesclarFiltros(
  atuais: FiltrosDocumentos,
  novo: Partial<FiltrosDocumentos>
): FiltrosDocumentos {
  const proximo = { ...atuais, ...novo };

  if (novo.busca) {
    return { ...proximo, fornecedor: '', numeroDoc: '', chaveNota: '' };
  }

  if (novo.fornecedor || novo.numeroDoc || novo.chaveNota) {
    return { ...proximo, busca: '' };
  }

  return proximo;
}
